import { useUsers } from 'hooks/users'
import React from 'react'
import User from './User'

const Users = () => {
    const { users, isLoading } = useUsers()
    if (isLoading) return "Loading ..."
    return (
        <div className='users-main-container'>
            {users?.map((user) => (
                <User key={user.username} user={user}/>
            ))}
        </div>
    )
}

export default Users